import { useContainer } from '../../useContainer';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { UpdateAssigneeDto } from '../../../commonTypes/project.types';
import { ICallback } from '../../../commonTypes/hook.types';
import { useTranslation } from '../../useTranslation';
import { AppError, ErrorCodes, getUserMessage, isErrorCode } from '../../../api/utils/ErrorHandler';

const useHttpPatchProjectAssignee = () => {
    const { t } = useTranslation('newNotifications');
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);

    const exec = (projectId: string, userSub: string, body: UpdateAssigneeDto, callback: ICallback) => {
        const { exec, clearCache, abort } = projectApi.updateAssignee({
            params: { projectId, userSub },
            body,
            onSuccess: _ => {
                toastHandler.push('success', t('projects.updateAssigneeTitle'), t('projects.updateAssigneeMessage_Success'));
                if (callback.onSuccess) callback.onSuccess();
                clearCache();
            },
            onError: (error: AppError | string) => {
                let message: string;
                if (isErrorCode(error, ErrorCodes.PROJECT_ASSIGNEE_EFFECTIVE_FROM_IN_FUTURE)) {
                    message = t('projects.updateAssigneeMessage_EffectiveFromInFuture');
                } else if (isErrorCode(error, ErrorCodes.PROJECT_ASSIGNEE_NO_RATE_ROW_FOR_DATE)) {
                    message = t('projects.updateAssigneeMessage_NoRateRowForDate');
                } else {
                    message = getUserMessage(error, t('projects.updateAssigneeMessage_Failed'));
                }
                toastHandler.push('error', t('projects.updateAssigneeTitle'), message);
                callback.onError?.(error);
            },
        });
        exec();
        return abort;
    };

    return { exec };
};

export default useHttpPatchProjectAssignee;
